import { render } from "./Hero.vue?vue&type=template&id=0cd5bd1f&scoped=true"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=0cd5bd1f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd5bd1f"]])

export default __exports__